import iconDefinitions from "./iconDefinitions";

type IconName = keyof typeof iconDefinitions;

type IconProps = {
  name: IconName;
  title?: string;
  className?: string;
};

const Icon = ({ name, title, ...rest }: IconProps) => {
  const iconDefinition =
    iconDefinitions[name] || Object.values(iconDefinitions)[0];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={iconDefinition.viewBox}
      width="100%"
      height="100%"
      fill="none"
      role="img"
      {...rest}
    >
      {title && <title>{title}</title>}
      {iconDefinition.svg}
    </svg>
  );
};

export { Icon };
export type { IconName };
